<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CKE4dx/tc-custom/9781426857911.jpg?1706098609726" alt="This image is the cover for the book Bought by the Greek Tycoon, The Greek Tycoons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bought by the Greek Tycoon, The Greek Tycoons
      </h1>
      <p class="bookDescription body article font2">
        <b>A tycoon tries to buy more time with a widow following their steamy one-night stand in this contemporary romance by a <i>USA Today</i> bestseller.</b><br/><br/>Greek multimillionaire Luke Devetzi will do anything to get Jemma Barnes back in his bed for a night of blazing passion. . . . <br/><br/>When Luke discovers that Jemma’s father is in financial trouble and in need of a loan, he is willing to pay it . . . but only if Jemma agrees to become his convenient wife!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jacqueline Baird
      </h2>
      
      <p class="authorDescription body article">When Jacqueline Baird is not busy writing she likes to spend her time travelling, reading and playing cards. She enjoys swimming in the sea when the weather allows. With a more sedentary lifestyle, she does visit a gym three times a week and has made the surprising discovery that she gets some of her best ideas while doing mind-numbingly boring exercises on the weight machines and airwalker. Jacqueline lives with her husband Jim in Northumberland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d6ff020